/**
 * 権限の出し分け（03 3.3.2・FE-D-025）：can(code) は permissions.includes(code)。ロール名（admin／user）で分岐しない。
 * 画面の出し分けは補助で、判定はサーバーが必ず行う（要件書 4.4）。
 */
import { useQueryClient } from '@tanstack/react-query';
import type { Me } from '@pcrm/shared';
import { ME_QUERY_KEY, useMe } from '../queries';

export interface PermissionChecker {
  is_loaded: boolean;
  can(permission_code: string): boolean;
  canAll(permission_codes: readonly string[]): boolean;
  canAny(permission_codes: readonly string[]): boolean;
}

export function checkerFor(me: Me | undefined): PermissionChecker {
  const granted = new Set(me?.permissions ?? []);
  return {
    is_loaded: me !== undefined,
    can: (permission_code) => granted.has(permission_code),
    canAll: (permission_codes) => permission_codes.every((code) => granted.has(code)),
    canAny: (permission_codes) => permission_codes.some((code) => granted.has(code)),
  };
}

export function usePermission(): PermissionChecker {
  const { data } = useMe({ is_fetch_enabled: false });
  const query_client = useQueryClient();
  return checkerFor(data ?? query_client.getQueryData<Me>(ME_QUERY_KEY));
}
